import { closeModalByName, ExitModal, requestResourceByName, useScopedSelector, WarningIcon } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';

export interface ConfirmResetAuthenticationFactorsProps {
}

const ConfirmResetAuthenticationFactors: FC<ConfirmResetAuthenticationFactorsProps> = () => {
  const { t } = useTranslation('AuthenticationFactors');
  const dispatch = useDispatch();
  const pending: boolean = useScopedSelector('ResetAuthenticationFactorsResource.pending');
  const theme = useTheme();

  return (
    <ExitModal
      name="confirmResetAuthenticationFactors"
      color={theme.colors.warning}
      Icon={WarningIcon}
      modalTitle={t('modalTitle')}
      modalMessage={t('modalMessage')}
      onCancel={() => { dispatch(closeModalByName('confirmResetAuthenticationFactors')); }}
      confirmButton={t('confirmButton')}
      onConfirm={() => {
        dispatch(requestResourceByName('ResetAuthenticationFactorsResource'));
        dispatch(closeModalByName('confirmResetAuthenticationFactors'));
      }}
      confirmBusy={pending}
      cancelDisabled={pending}
    />
  );
};

export default ConfirmResetAuthenticationFactors;
